export const LOGIN = 'loginPage/LOGIN';
export const LOGGED_IN = 'loginPage/LOGGED_IN';
export const LOGIN_REDIRECT = 'loginPage/LOGIN_REDIRECT';
export const VALIDATE_AUTH_CODE = 'loginPage/VALIDATE_AUTH_CODE';
